const colorsForChart = ['#0d6efd', '#6610f2', '#d63384', '#fd7e14', '#ffc107', '#198754', '#20c997', '#6f42c1', '#0dcaf0', '#adb5bd', '#dc3545', '#000'];

export { colorsForChart };
